var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3789_37159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.476562C5.63761 0.476562 0.480011 5.63416 0.480011 11.9966C0.480011 18.359 5.63761 23.5166 12 23.5166C18.3624 23.5166 23.52 18.359 23.52 11.9966C23.52 5.63416 18.3624 0.476562 12 0.476562ZM9.18001 16.7714H6.84721V9.26416H9.18001V16.7714ZM7.99921 8.34256C7.26241 8.34256 6.78601 7.82056 6.78601 7.17496C6.78601 6.51616 7.27681 6.00976 8.02921 6.00976C8.78161 6.00976 9.24241 6.51616 9.25681 7.17496C9.25681 7.82056 8.78161 8.34256 7.99921 8.34256ZM17.7 16.7714H15.3672V12.611C15.3672 11.6426 15.0288 10.985 14.1852 10.985C13.5408 10.985 13.158 11.4302 12.9888 11.8586C12.9264 12.011 12.9108 12.227 12.9108 12.4418V16.7702H10.5768V11.6582C10.5768 10.721 10.5468 9.93736 10.5156 9.26296H12.5424L12.6492 10.3058H12.696C13.0032 9.81616 13.7556 9.09376 15.0144 9.09376C16.5492 9.09376 17.7 10.1222 17.7 12.3326V16.7714Z",
    fill: "#374DA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3789_37159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c27926ef600c66f3ed628c21f1bf7b4d.svg";
export { ForwardRef as ReactComponent };